import { Controller } from "stimulus"
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo
import moment from 'moment'

export default class extends Controller {
  static targets = [ "period", "date", "end", "datecontainer", "endcontainer", "store", "loader" ]
  static values = {
    next: String
  }

  connect() {
    if (this.period === 0 || this.period === "0") {
      this.datecontainerTarget.classList.remove('hidden')
      this.endcontainerTarget.classList.remove('hidden')
    }
  }
  
  change_period() {
    console.log(`${this.period}`)

    let date
    let end
    switch(this.period){
      case "1":
        date = moment()

        this.dateTarget.value = moment(date).format('DD/MM/YYYY')
        this.endTarget.value = moment(date).format('DD/MM/YYYY')

        this.change_date()
        break;
      case "-1":
        date = moment()
        date = moment(date).subtract(1, 'day')

        this.dateTarget.value = moment(date).format('DD/MM/YYYY')
        this.endTarget.value = moment(date).format('DD/MM/YYYY')

        this.change_date()
        break;
      case "7":
        date = moment()
        date = moment(date).startOf('isoWeek')
        end = moment(date).endOf('isoWeek')

        this.dateTarget.value = moment(date).format('DD/MM/YYYY')
        this.endTarget.value = moment(end).format('DD/MM/YYYY')

        this.change_date()
        break;
      case "-7":
        date = moment().startOf('isoWeek').subtract(7,'days')
        end = moment().endOf('isoWeek').subtract(7, 'days')

        this.dateTarget.value = moment(date).format('DD/MM/YYYY')
        this.endTarget.value = moment(end).format('DD/MM/YYYY')

        this.change_date()
        break;
      case "30":
        date = moment().startOf('month')
        end = moment().endOf('month')

        this.dateTarget.value = moment(date).format('DD/MM/YYYY')
        this.endTarget.value = moment(end).format('DD/MM/YYYY')

        this.change_date()
        break;
      case "-30":
        date = moment().startOf('month').subtract(1,'month')
        end = moment().endOf('month').subtract(1, 'month')

        this.dateTarget.value = moment(date).format('DD/MM/YYYY')
        this.endTarget.value = moment(end).format('DD/MM/YYYY')

        this.change_date()
        break;
      case "365":
        date = moment().startOf('year')
        end = moment().endOf('year')

        this.dateTarget.value = moment(date).format('DD/MM/YYYY')
        this.endTarget.value = moment(end).format('DD/MM/YYYY')

        this.change_date()
        break;
      case "-365":
        date = moment().startOf('year').subtract(1,'year')
        end = moment().endOf('year').subtract(1, 'year')

        this.dateTarget.value = moment(date).format('DD/MM/YYYY')
        this.endTarget.value = moment(end).format('DD/MM/YYYY')

        this.change_date()
        break;
      default:
        this.datecontainerTarget.classList.remove('hidden')
        this.endcontainerTarget.classList.remove('hidden')
        console.log('Setting custom date, no redirect...')
    }

  }

  change_store() {
    this.change_period()
  }

  change_date() {
    console.log(`${this.period}/${this.store}/${this.date}/${this.end}`)

    let url = `${window.location.origin}/reportes/${this.period}/${this.store}/${this.date}/${this.end}`
    console.log(url)
    this.loaderTarget.classList.remove('hidden')

    Turbo.visit(url, { action: "advance" })
  }

  get period() {
    return this.periodTarget.value
  }

  get date() {
    return this.dateTarget.value
  }

  get end() {
    return this.endTarget.value
  }

  get store() {
    return this.storeTarget.value
  }
}
